import { render, staticRenderFns } from "./TagsItem.vue?vue&type=template&id=4ffbbd4d&scoped=true&"
import script from "./TagsItem.vue?vue&type=script&lang=js&"
export * from "./TagsItem.vue?vue&type=script&lang=js&"
import style0 from "./TagsItem.vue?vue&type=style&index=0&id=4ffbbd4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffbbd4d",
  null
  
)

export default component.exports